import React, { useState } from 'react';
import { FaTimesCircle } from 'react-icons/fa';

function RejectionModal({ application, onConfirm, onClose }) {
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [loading, setLoading] = useState(false);

  const predefinedReasons = [
    'Sənədlər tam deyil',
    'VÖEN yoxlanılması uğursuz',
    'Əlaqə məlumatları düzgün deyil',
    'Lisenziya problemi',
    'Təkrar müraciət',
    'Digər',
  ];

  const handleConfirm = async () => {
    const reason = selectedReason === 'Digər' ? customReason : selectedReason;

    if (!reason) {
      alert('Zəhmət olmasa səbəb seçin və ya yazın!');
      return;
    }

    setLoading(true);
    await onConfirm(reason);
    setLoading(false);
  };

  return (
    <>
      <div style={styles.overlay} onClick={onClose}></div>
      <div style={styles.modal}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerIcon}>
            <FaTimesCircle size={40} color="#F44336" />
          </div>
          <h2 style={styles.title}>❌ Müraciəti Rədd Et</h2>
        </div>

        <div style={styles.content}>
          {/* Business Info */}
          <div style={styles.businessInfo}>
            <h3 style={styles.businessName}>{application.company_name}</h3>
            <p style={styles.businessDetail}>VÖEN: {application.voen}</p>
            <p style={styles.businessDetail}>Email: {application.email}</p>
          </div>

          {/* Warning */}
          <div style={styles.warningBox}>
            <p style={styles.warningText}>
              ⚠️ Rədd etdikdən sonra bu müraciət "rejected" statusuna keçəcək və business-ə email göndəriləcək.
            </p>
          </div>

          {/* Reason Selection */}
          <div style={styles.reasonSection}>
            <h4 style={styles.reasonTitle}>Rədd Səbəbi Seçin:</h4>

            <div style={styles.reasonList}>
              {predefinedReasons.map((reason) => (
                <label key={reason} style={styles.reasonLabel}>
                  <input
                    type="radio"
                    name="reason"
                    value={reason}
                    checked={selectedReason === reason}
                    onChange={(e) => setSelectedReason(e.target.value)}
                    style={styles.radio}
                  />
                  <span style={styles.reasonText}>{reason}</span>
                </label>
              ))}
            </div>

            {selectedReason === 'Digər' && (
              <div style={styles.customReasonBox}>
                <label style={styles.customReasonLabel}>Səbəbi yazın:</label>
                <textarea
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                  placeholder="Rədd səbəbini ətraflı yazın..."
                  style={styles.textarea}
                  rows={4}
                />
              </div>
            )}
          </div>

          {/* Info Box */}
          <div style={styles.infoBox}>
            <h4 style={styles.infoTitle}>Rədd edildikdə:</h4>
            <ul style={styles.infoList}>
              <li>❌ Status "Rədd edilmiş" olaraq dəyişəcək</li>
              <li>📧 Business-ə email bildirişi göndəriləcək</li>
              <li>📝 Rədd səbəbi qeyd olunacaq</li>
              <li>🔍 Business status səhifəsində görsənəcək</li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <button onClick={onClose} style={styles.btnCancel} disabled={loading}>
            Ləğv Et
          </button>
          <button onClick={handleConfirm} style={styles.btnConfirm} disabled={loading}>
            {loading ? 'Rədd edilir...' : '❌ Rədd Et'}
          </button>
        </div>
      </div>
    </>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 2000,
  },
  modal: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    borderRadius: '16px',
    width: '95%',
    maxWidth: '600px',
    maxHeight: '90vh',
    overflowY: 'auto',
    zIndex: 2001,
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  },
  header: {
    padding: '30px',
    borderBottom: '2px solid #F0F0F0',
    textAlign: 'center',
  },
  headerIcon: {
    marginBottom: '15px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    margin: 0,
  },
  content: {
    padding: '30px',
  },
  businessInfo: {
    backgroundColor: '#F8F9FA',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  businessName: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '10px',
  },
  businessDetail: {
    fontSize: '14px',
    color: '#666',
    margin: '5px 0',
  },
  warningBox: {
    backgroundColor: '#FFEBEE',
    padding: '15px',
    borderRadius: '8px',
    border: '2px solid #F44336',
    marginBottom: '25px',
  },
  warningText: {
    fontSize: '14px',
    color: '#C62828',
    margin: 0,
    fontWeight: '500',
  },
  reasonSection: {
    marginBottom: '25px',
  },
  reasonTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '15px',
  },
  reasonList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  reasonLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    border: '2px solid #E0E0E0',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  radio: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    flexShrink: 0,
  },
  reasonText: {
    fontSize: '14px',
    color: '#1A1A2E',
  },
  customReasonBox: {
    marginTop: '15px',
  },
  customReasonLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1A1A2E',
    display: 'block',
    marginBottom: '8px',
  },
  textarea: {
    width: '100%',
    padding: '12px',
    fontSize: '14px',
    border: '2px solid #E0E0E0',
    borderRadius: '8px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
  },
  infoBox: {
    backgroundColor: '#F8F9FA',
    padding: '20px',
    borderRadius: '12px',
  },
  infoTitle: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '12px',
  },
  infoList: {
    margin: 0,
    paddingLeft: '20px',
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.8',
  },
  footer: {
    padding: '20px 30px',
    borderTop: '2px solid #F0F0F0',
    display: 'flex',
    gap: '15px',
    justifyContent: 'flex-end',
  },
  btnCancel: {
    padding: '12px 24px',
    backgroundColor: '#E0E0E0',
    color: '#1A1A2E',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  btnConfirm: {
    padding: '12px 24px',
    backgroundColor: '#F44336',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
};

export default RejectionModal;